{
  "unavailable": "The overview is unavailable",
  "unavailableHint": "The network summary needs permission to read nodes; the platform summary needs permission for sites. Ask your organization administrator for them.",
  "availability": {
    "noData": "no data"
  },
  "network": {
    "title": "Network",
    "computedAt": "computed at {{at}}",
    "loading": "Computing the network summary…",
    "failed": "Could not compute the network summary",
    "failedHint": "{{reason}} Check the connection to the server — the network itself is unaffected."
  },
  "platform": {
    "title": "Platform",
    "subtitle": "version {{version}} · api up for {{uptime}}",
    "loading": "Polling the platform…",
    "failed": "Could not read the platform state",
    "failedHint": "{{reason}} If api itself is silent, the header indicator shows it too."
  },
  "tile": {
    "nodesTotal": "Nodes in total",
    "monitorsEnabled_one": "{{enabled}} of {{count}} monitor enabled",
    "monitorsEnabled_other": "{{enabled}} of {{count}} monitors enabled",
    "down": "Down",
    "checksFailing_one": "{{count}} check is failing",
    "checksFailing_other": "{{count}} checks are failing",
    "allAnswering": "every node answers",
    "warn": "Alarming",
    "warnHint": "some of the node's checks are failing",
    "unknown": "Unknown",
    "withoutMonitors_one": "{{count}} with no monitor at all",
    "withoutMonitors_other": "{{count}} with no monitor at all",
    "noChecksYet": "no checks have run yet",
    "availabilityDay": "Availability, 24 h",
    "availabilityWeek": "Over a week",
    "availabilityMonth": "Over a month",
    "agentsOnline": "Agents connected",
    "agentsLost_one": "{{count}} lost contact",
    "agentsLost_other": "{{count}} lost contact",
    "allSitesOnline": "every site is connected",
    "vncSessions": "VNC sessions",
    "openNow": "open right now",
    "videoStreams": "Video streams",
    "archiveCount": "archive: {{count}}",
    "backup": "Backup",
    "backupUnknown": "state unknown",
    "databaseSize": "Database size"
  },
  "flapping": {
    "title": "Went down most often in 24 h",
    "downs": "Downs",
    "transitions": "Changes",
    "empty": "Nothing went down in 24 hours",
    "emptyHint": "The list fills up when a node goes down. An empty list here is good news, not missing data."
  },
  "events": {
    "title": "Recent events",
    "emptyHint": "Monitor state changes from every site in the organization land here. Records appear when a node stops answering or comes back."
  },
  "column": {
    "uptime": "Uptime",
    "lastSeen": "Seen"
  },
  "dependencies": "Dependencies",
  "databaseTables": "What fills the database",
  "siteAgents": "Site agents",
  "noAgents": "No agents at all",
  "noAgentsHint": "The agent is the only thing installed in the customer's network. Add one under Agents and start it on the site server.",
  "noChecks": "no checks ran in this period",
  "dependency": {
    "answeredIn": "Answered in {{ms}} ms",
    "ms": "{{ms}} ms",
    "silent": "not responding"
  },
  "agent": {
    "online": "{{name}}: connected",
    "lost": "{{name}}: contact lost",
    "never": "{{name}}: has never connected"
  },
  "database": {
    "empty": "the database is empty",
    "telemetryShare": "{{size}} of telemetry — {{share}} %",
    "unreadable": "The database size could not be read: check the application role's permissions on pg_catalog"
  },
  "backup": {
    "dirNotSet": "The backup directory is not set: the NETDECK_BACKUP_DIR variable is empty",
    "dirMissing": "The backup directory {{directory}} does not exist",
    "dirUnreadable": "The backup directory {{directory}} cannot be read: {{code}}",
    "noCopies": "The {{directory}} directory holds no backups",
    "copiesUnreadable": "The backup files in {{directory}} are listed, but none of them can be read"
  },
  "media": {
    "notChecked": "the media server state was not checked"
  },
  "uptime": {
    "seconds_one": "{{count}} s",
    "seconds_other": "{{count}} s",
    "days": "{{days}} d {{hours}} h",
    "hours": "{{hours}} h {{minutes}} min",
    "minutes_one": "{{count}} min",
    "minutes_other": "{{count}} min"
  }
}
